var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbAppIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.52,
    height: 20.01,
    viewBox: "0 0 17.52 20.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.12 112.12a.62.62 0 1 0-1.24 0v8.75a.62.62 0 1 0 1.24 0zm-3.74 0a.62.62 0 1 0-1.24 0v8.75a.62.62 0 1 0 1.24 0zm-3.76 0a.62.62 0 1 0-1.24 0v8.75a.62.62 0 1 0 1.24 0zm10.63-2.65v12.66a1.88 1.88 0 0 1-1.88 1.88H30.12a1.88 1.88 0 0 1-1.88-1.88v-12.66a.47.47 0 0 1 .47-.47h14.06a.47.47 0 0 1 .48.47M27 107.28v-1.09a.94.94 0 0 1 .94-.94h4.38l.37-.73a.93.93 0 0 1 .84-.52h4.46a.93.93 0 0 1 .84.52l.37.73h4.38a.94.94 0 0 1 .94.94v1.09a.47.47 0 0 1-.47.47H27.47a.47.47 0 0 1-.47-.47",
    "data-name": "Path 1184"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h30v30H-1z",
    "data-name": "Rectangle 6309"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11790",
    style: {
      clipPath: "url(#a)"
    },
    transform: "translate(-27 -104)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11789",
    style: {
      clipPath: "url(#b)"
    },
    transform: "translate(22 99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.5v30H0z",
    "data-name": "Rectangle 6308",
    style: {
      fill: "#333"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbAppIconDelete);
export default __webpack_public_path__ + "static/media/tb_app_icon_delete.52c3f7caa586eea7c52053c673c0f6e7.svg";
export { ForwardRef as ReactComponent };